//components\IncomingOrders\helpers\actions.js
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import { Box } from "@mui/material";

// const NoActionIcon = () => (
//   <Box sx={{ position: "relative", display: "inline-flex" }}>
//     <BoltOutlinedIcon fontSize="small" />
//     <BlockOutlinedIcon
//       fontSize="small"
//       sx={{
//         position: "absolute",
//         top: -4,
//         left: -4,
//         color: "error.main",
//         fontSize: 18,
//       }}
//     />
//   </Box>
// );

// const NoActionIcon = (props) => (
//   <Box
//     sx={{
//       position: "relative",
//       display: "inline-flex",
//       alignItems: "center",
//       justifyContent: "center",
//     }}
//   >
//     <BoltOutlinedIcon {...props} />

//     <Box
//       sx={{
//         position: "absolute",
//         width: "140%",
//         height: "2px",
//         backgroundColor: "currentColor",
//         transform: "rotate(-35deg)",
//       }}
//     />
//   </Box>
// );

const NoActionIcon = ({ fontSize = "small", ...props }) => (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      color: "text.disabled",
      transition: "opacity 0.2s ease",
      "&:hover": {
        opacity: 0.8,
      },
    }}
  >
    <BoltOutlinedIcon fontSize={fontSize} {...props} />

    <Box
      sx={{
        position: "absolute",
        width: "120%",
        height: "1.5px",
        backgroundColor: "currentColor",
        transform: "rotate(-32deg)",
        borderRadius: "2px",
        opacity: 0.9,
        pointerEvents: "none",
      }}
    />
  </Box>
);

const ACTION = {
  NONE: "NONE",
  SEND_ORDER_CONFIRMATION: "SEND_ORDER_CONFIRMATION",
  SEND_DELIVERY_CONFIRMATION: "SEND_DELIVERY_CONFIRMATION",
  CREATE_INVOICE: "CREATE_INVOICE",
  CREATE_INVOICE_DRAFT: "CREATE_INVOICE_DRAFT",
  PREPARE_PRINT_PICKING_LIST: "PREPARE_PRINT_PICKING_LIST",
};

export const ACTIONS = {
  NONE: {
    labelId: "incomingOrders.actions.none",
    doneLabelId: "incomingOrders.actions.none.done",
    failLabelId: "incomingOrders.actions.none.fail",

    label: "Ingen åtgärd",
    doneLabel: "Ingen åtgärd utförd",
    failLabel: "Ingen åtgärd utförd",

    icon: NoActionIcon,
  },
  SEND_ORDER_CONFIRMATION: {
    labelId: "incomingOrders.actions.sendOrderConfirmation",
    doneLabelId: "incomingOrders.actions.sendOrderConfirmation.done",
    failLabelId: "incomingOrders.actions.sendOrderConfirmation.fail",

    label: "Skicka orderbekräftelse",
    doneLabel: "Skickade orderbekräftelse",
    failLabel: "Orderbekräftelse skickades inte",

    icon: FactCheckOutlinedIcon,
  },
  SEND_DELIVERY_CONFIRMATION: {
    labelId: "incomingOrders.actions.sendDeliveryConfirmation",
    doneLabelId: "incomingOrders.actions.sendDeliveryConfirmation.done",
    failLabelId: "incomingOrders.actions.sendDeliveryConfirmation.fail",

    label: "Skicka leveransbekräftelse",
    doneLabel: "Skickade leveransbekräftelse",
    failLabel: "Leveransbekräftelse skickades inte",

    icon: LocalShippingOutlinedIcon,
  },
  CREATE_INVOICE: {
    labelId: "incomingOrders.actions.createInvoice",
    doneLabelId: "incomingOrders.actions.createInvoice.done",
    failLabelId: "incomingOrders.actions.createInvoice.fail",

    label: "Skapa faktura",
    doneLabel: "Skapade faktura",
    failLabel: "Faktura skapades inte",

    icon: LocalShippingOutlinedIcon,
  },
  CREATE_INVOICE_DRAFT: {
    labelId: "incomingOrders.actions.createInvoiceDraft",
    doneLabelId: "incomingOrders.actions.createInvoiceDraft.done",
    failLabelId: "incomingOrders.actions.createInvoiceDraft.fail",

    label: "Skapa fakturautkast",
    doneLabel: "Skapade fakturautkast",
    failLabel: "Fakturautkast skapades inte",

    icon: LocalShippingOutlinedIcon,
  },
  PREPARE_PRINT_PICKING_LIST: {
    labelId: "incomingOrders.actions.preparePrintPickingList",
    doneLabelId: "incomingOrders.actions.preparePrintPickingList.done",
    failLabelId: "incomingOrders.actions.preparePrintPickingList.fail",

    label: "Skriv ut plocklista",
    doneLabel: "Skrev ut plocklista",
    failLabel: "Plocklista skrevs inte ut",

    icon: LocalShippingOutlinedIcon,
  }
};

export const getActionLabel = (actionType, intl) => {
  const action = ACTIONS[actionType];
  if (!action) return actionType;
  return action.labelId && intl
    ? intl.formatMessage({ id: action.labelId })
    : action.label;
};

export const getActionDoneMessages = (actions = [], intl) => {
  return actions
    .map((a) => {
      const action = ACTIONS[a];
      if (!action) return null;
      return action.doneLabelId && intl
        ? intl.formatMessage({ id: action.doneLabelId })
        : action.doneLabel;
    })
    .filter(Boolean);
};

export const getActionFailMessages = (actions = [], intl) => {
  return actions
    .map((a) => {
      const action = ACTIONS[a];
      if (!action) return null;
      return action.failLabelId && intl
        ? intl.formatMessage({ id: action.failLabelId })
        : action.failLabel;
    })
    .filter(Boolean);
};

export const processActionResponses = (actionResponses = [], intl) => {
  var doneMessages = [];
  var failMessages = [];

  actionResponses.forEach(response => {
    if (response.action === ACTION.PREPARE_PRINT_PICKING_LIST) {
      window.open(response.url, "_blank", "noopener");
    }

    var action = ACTIONS[response.action];

    if (!action)
      return;

    if (response.success) {
      doneMessages.push(
        (action.doneLabelId && intl)
          ? intl.formatMessage({ id: action.doneLabelId })
          : action.doneLabel);
    }
    else {
      failMessages.push(
        (action.failLabelId && intl)
          ? intl.formatMessage({ id: action.failLabelId })
          : action.failLabel);
    }
  });

  return { doneMessages, failMessages };
};

export const getConcatenatedActionLabels = (actionValues, intl, delimiter = " | ") =>
  actionValues
    .map(actionValue => {
      var action = ACTIONS[actionValue];
      if (action) {
        return (action.labelId && intl) ? intl.formatMessage({ id: action.labelId }) : action.label;
      }
    })
    .filter(Boolean)
    .join(delimiter);

//export const ACTION_TYPES = Object.keys(ACTION_LABELS);